<template>
  <FormPanel
      headline="Create Topic"
      :errors="errors"
      :portal="portal"
      @submit="submit"
  />
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentTopics/Panels/Form'

export default {
  components: {FormPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      errors: {}
    }
  },

  methods: {
    submit(data) {
      http.post('/api/v2/content-topics', {...data, portal_id: this.portal.id})
          .then(() => {
            notify.success('The content topic was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/topics')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
